import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppTableComponent, Auth, MessagesComponent, OpnSupplierListModel, OpnSupplierListService, RequestsService, RequestStatusUniqueIdentifier, SearchModel, SearchResultModel, TranslationManager, ViewState } from 'src/common';
import { ActivatedRoute } from '@angular/router';
import { SupplierSelectComponent } from 'src/views/components/supplier-select';
import { RequestBasicInformationComponent } from '../../request-basic-information/request-basic-information.component';

@Component({
  selector: 'opn-suppliers-list',
  templateUrl: 'opn-suppliers-list.component.html'
})

export class OpnSuppliersListComponent implements AfterViewInit {

  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  @Input() requestId: number;
  @Input() state: ViewState;
  viewState = ViewState;

  @ViewChild('supplierSelect') supplierSelect: SupplierSelectComponent;
  @ViewChild('requestBasicInformationComponent') requestBasicInformationComponent: RequestBasicInformationComponent;

  constructor(private requestService: RequestsService,
    private opnSuppliersListsService: OpnSupplierListService,
    private router: Router,
    private route: ActivatedRoute) { }
  items: OpnSupplierListModel[];
  idForDelete: number;
  showDeleteModal: boolean = false;
  auth = Auth;

  translationManager = TranslationManager;
  requestStatusUniqueIdentifier = RequestStatusUniqueIdentifier;
  requestStatus: string;

  ngOnInit(): void {
    this.requestService.getRequestStatusUnique(this.requestId).then(result => {
      this.requestStatus = result.requestStatus;
    });
  }

  ngAfterViewInit(): void {
    // this.appTable.onSearch = this.doSearch.bind(this);
    // this.appTable.search();
    this.getAll();
  }


  // doSearch(search: SearchModel) {
  //   this.requestService.opnSuppliersListSearch(search, this.requestId).then((result: SearchResultModel<OpnSupplierListModel>) => {
  //     this.items = result.items;
  //     //this.appTable.setTotalCount(result.totalCount);
  //   });
  // }


  getAll() {
    this.requestService.opnSuppliersListGetAll(this.requestId).then(result => {
      this.items = result;
    })
  }

  showDeleteModalFor(id: number) {
    this.idForDelete = id;
    this.showDeleteModal = true;
  }

  delete() {
    if (this.idForDelete > 0) {
      this.opnSuppliersListsService.delete(this.idForDelete).then(() => {
        this.idForDelete = 0;
        this.showDeleteModal = false;
        this.getAll();
        MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно обрисани')]);
      }).catch((reason: any) => {
        MessagesComponent.instance.showError([reason.error.messages]);
      });
    }
  }

  selectSuppliers() {
    this.supplierSelect.showModal(this.requestId).then((check: boolean) => {
      if (check) {
       this.getAll();
       MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно сачувани')]);
      }
    });


  }

}
